import * as React from "react";
import { forwardRef } from "react";
const SvgToolProbe = ({
  title,
  titleId,
  ...props
}, ref) => <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 22 22" ref={ref} aria-labelledby={titleId} {...props}>{title ? <title id={titleId}>{title}</title> : null}<g fill="none" fillRule="evenodd" stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" strokeWidth={1.5} transform="translate(1 1)"><path d="M10 0L10 3.333M10 16.667L10 20M0 10L3.333 10M16.667 10L20 10" /><circle cx={10} cy={10} r={6.667} /><path d="M10 9.583c.23 0 .417.187.417.417 0 .23-.187.417-.417.417-.23 0-.417-.187-.417-.417 0-.23.187-.417.417-.417" /></g></svg>;
const ForwardRef = forwardRef(SvgToolProbe);
export { ForwardRef as ReactComponent };